import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import './NewBudgetModal.css';
import FormModal from 'components/shared/modal/FormModal';
import ConfirmationPanel from 'components/shared/confirmation/ConfirmationPanel';
import checkCirclePng from 'images/check-circle.png';
import Button from 'components/shared/button/Button';
import TasksReviewTable from 'components/admin/work-orders/details/proposals/TasksReviewTable';
import QualificationsContainer from 'components/admin/work-orders/details/qualifications/QualificationsContainer';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import {
  getCurrentView,
  getPdf,
  getShow,
  getShowPdfViewer,
  getValuesByTaskId,
} from 'selectors/admin/work-orders/details/budget';
import {
  getQualifications,
  getSelectedQualificationsById,
} from 'selectors/admin/work-orders/details/qualifications';
import {
  back,
  closePdfViewer,
  createBudgetRequest,
  declineBudget,
  next,
  openApproveReviewModal,
  printBudget,
  setShow,
  setShowEmailModal,
  updateBudgetRequest,
  updateExtraCosts,
  updateValue,
} from 'actions/admin/work-orders/details/budget';
import TaskBudget from 'components/admin/work-orders/details/budget/TaskBudget';
import CostsDatesProposal from 'components/admin/work-orders/details/proposals/CostsDatesProposal';
import { getBudget } from 'selectors/admin/work-orders/details/details';
import DeclineModal from 'components/shared/modal/DeclineModal';
import { push } from 'react-router-redux';
import { baseRoutePath } from 'actions/admin/work-orders/work-orders';
import mailSvg from 'images/mail.svg';
import printSvg from 'images/print.svg';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import BudgetEmailModal from 'components/admin/work-orders/details/budget/BudgetEmailModal';
import MessageModal from 'components/shared/modal/MessageModal';
import invalidPng from 'images/invalid.png';

class NewBudgetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeclineModal: false,
      showHasChangeMessageModal: false,
    };
  }

  render() {
    const couldGoBack = this.props.currentView === 'review';
    let title;
    const version =
      this.props.budget !== null ? `#${this.props.budget.version_number} ` : '';
    const postTitle = `Preliminary Estimate ${version}(WO #${
      this.props.currentWorkOrder.number
    }${NewBudgetModal.getWorkOrderName(this.props.currentWorkOrder)})`;

    let mainComponent;
    switch (this.props.currentView) {
      case 'form':
        mainComponent = this.renderForm();
        title = postTitle;
        break;
      case 'review':
        mainComponent = this.renderReview();
        title = postTitle;
        break;
      case 'thank-you':
        mainComponent = this.renderThankYou();
        break;
      default:
        mainComponent = null;
    }

    return this.props.show ? (
      <FormModal
        className="new-budget-modal"
        show={this.props.show}
        showHeader={this.props.currentView !== 'thank-you'}
        title={title}
        onBack={couldGoBack ? this.handleBack : undefined}
        onClose={this.handleClose}
      >
        {mainComponent}
      </FormModal>
    ) : null;
  }

  renderForm() {
    return (
      <div className="items-container">
        <div className="task-budget-items">
          {this.props.tasks.map((task) => {
            return (
              <div key={task.id}>
                <TaskBudget
                  taskNumber={task.number}
                  taskTrade={task.trade.label}
                  values={this.props.valuesByTaskId[task.id]}
                  onValueBlur={(valueKey, value) =>
                    this.handleValueBlur(task.id, valueKey, value)
                  }
                  onValueChange={(valueKey, value) =>
                    this.handleValueChange(task.id, valueKey, value)
                  }
                />
              </div>
            );
          })}
        </div>

        <QualificationsContainer />

        <div className="button-container">
          <Button
            className="button-orange"
            disabled={!this.isReviewButtonEnable()}
            label="Review"
            onClick={this.handleButton}
          />
        </div>
      </div>
    );
  }

  renderReview() {
    const { budget, tasks, valuesByTaskId } = this.props;
    let total = 0;
    const values = tasks.map((task) => {
      const taskValues = valuesByTaskId[task.id];
      let taskTotal = 0;
      if (taskValues) {
        taskTotal =
          taskValues.cost +
          taskValues.fee +
          taskValues.markup +
          taskValues.insurance;
      }
      total += taskTotal;
      return {
        id: task.id,
        number: task.number,
        details: task.name !== null ? task.name : task.trade.label,
        cost: taskTotal,
      };
    });

    return (
      <div className="items-container">
        <TasksReviewTable values={values} />

        <div className="total-container">
          <div className="buttons">
            <Button
              className="button-white"
              icon={mailSvg}
              label="Email"
              onClick={this.handleEmail}
            />
            <Button
              className="button-white print-button"
              icon={printSvg}
              label="Print"
              onClick={this.handlePrint}
            />
          </div>

          <CostsDatesProposal total={total} />
        </div>

        <QualificationsContainer readOnly={true} />

        <div className="button-container">
          {budget !== null && (
            <Button
              className="button-white"
              label="Decline"
              onClick={this.handleDecline}
            />
          )}
          {budget !== null && (
            <Button
              className="button-gray"
              label="Edit"
              onClick={this.handleBack}
            />
          )}
          <Button
            className="button-orange"
            label={budget === null ? 'Submit' : 'Update'}
            onClick={this.handleButton}
          />
          {budget !== null && (
            <Button
              className="button-orange"
              label="Approve"
              onClick={this.handleApprove}
            />
          )}
        </div>

        <DeclineModal
          show={this.state.showDeclineModal}
          onSubmit={this.handleDeclineSubmit}
        />

        <PdfViewer
          content={{
            source: this.props.pdf,
            type: 'blob',
          }}
          show={this.props.showPdfViewer}
          onClose={this.handlePdfViewerClose}
        />

        <BudgetEmailModal />

        <MessageModal
          show={this.state.showHasChangeMessageModal}
          icon={invalidPng}
          message="Please update first to see the updated printed view."
          onHide={() => this.setState({ showHasChangeMessageModal: false })}
        />
      </div>
    );
  }

  renderThankYou() {
    return (
      <ConfirmationPanel
        image={checkCirclePng}
        firstLine="Thank you!"
        lines={[
          `Preliminary Estimate for WO #${this.props.currentWorkOrder.number} has been sent
            to ${this.props.currentWorkOrder.client.company_name}.`,
        ]}
        buttons={[
          <input
            type="button"
            className="btn button button-orange"
            value="Continue"
            onClick={this.handleThankYou}
          />,
        ]}
      />
    );
  }

  handleBack = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.dispatch(back(this.props.currentView));
  };

  handleButton = () => {
    if (this.props.currentView === 'review') {
      if (this.props.budget === null) {
        this.props.dispatch(
          createBudgetRequest(
            this.props.currentWorkOrder.id,
            this.props.valuesByTaskId,
            this.props.qualifications,
            this.props.selectedQualificationsById
          )
        );
      } else {
        this.props.dispatch(
          updateBudgetRequest(
            this.props.currentWorkOrder.id,
            this.props.budget,
            this.props.valuesByTaskId,
            this.props.qualifications,
            this.props.selectedQualificationsById
          )
        );
      }
    } else {
      this.props.dispatch(next(this.props.currentView));
    }
  };

  handleClose = (event) => {
    event.preventDefault();
    this.props.dispatch(setShow(false));
  };

  handleDecline = () => {
    this.setState({ showDeclineModal: true });
  };

  handleDeclineSubmit = (values) => {
    if (values.sure === 'yes') {
      this.props
        .dispatch(declineBudget(this.props.currentWorkOrder.id, values))
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(push(baseRoutePath));
          }
        });
    } else {
      this.setState({ showDeclineModal: false });
    }
  };

  handleEmail = () => {
    const { budget, selectedQualificationsById, valuesByTaskId } = this.props;
    if (
      NewBudgetModal.hasDataChange(
        budget,
        valuesByTaskId,
        selectedQualificationsById
      )
    ) {
      this.setState({ showHasChangeMessageModal: true });
    } else {
      this.props.dispatch(setShowEmailModal(true));
    }
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(closePdfViewer());
  };

  handlePrint = () => {
    const { budget, selectedQualificationsById, valuesByTaskId } = this.props;
    if (
      NewBudgetModal.hasDataChange(
        budget,
        valuesByTaskId,
        selectedQualificationsById
      )
    ) {
      this.setState({ showHasChangeMessageModal: true });
    } else {
      this.props.dispatch(printBudget(this.props.currentWorkOrder.id));
    }
  };

  handleValueBlur = (taskId, valueKey, value) => {
    // Round value
    this.props.dispatch(updateValue(taskId, valueKey, Math.round(value)));
    if (valueKey === 'cost') {
      this.props.dispatch(updateExtraCosts(taskId, Math.round(value)));
    }
  };

  handleValueChange = (taskId, valueKey, value) => {
    this.props.dispatch(updateValue(taskId, valueKey, value));
  };

  handleThankYou = () => {
    this.props.dispatch(setShow(false));
  };

  handleApprove = () => {
    this.props.dispatch(openApproveReviewModal(this.props.budget));
  };

  static getWorkOrderName(workOrder) {
    return workOrder.name !== null && workOrder.name !== ''
      ? `: ${workOrder.name}`
      : '';
  }

  isReviewButtonEnable() {
    let optionUndefinedForQualification = false;
    Object.keys(this.props.selectedQualificationsById).forEach((key) => {
      const qualification = this.props.qualifications.find(
        (qualification) => qualification.id === numeral(key).value()
      ); // object.keys returns string
      if (qualification !== undefined && qualification.options.length > 0) {
        optionUndefinedForQualification =
          optionUndefinedForQualification ||
          this.props.selectedQualificationsById[key].option === null;
      }
    });

    // If no tasks, then default to false, otherwise will be true and checks that ALL costs are not null
    let allCostsWithValue = this.props.tasks.length > 0;
    Object.values(this.props.valuesByTaskId).forEach((value) => {
      allCostsWithValue =
        allCostsWithValue &&
        value.cost !== null &&
        value.cost !== '' &&
        value.cost > 0;
    });

    return !optionUndefinedForQualification && allCostsWithValue;
  }

  static hasDataChange(budget, valuesByTaskId, selectedQualificationsById) {
    // Check tasks values
    const taskValuesChanged = Object.keys(valuesByTaskId).some((taskId) => {
      const budgetTask = budget.budget_tasks.find(
        (budgetTask) => budgetTask.task_id === numeral(taskId).value()
      );
      if (budgetTask === undefined) {
        return true;
      } else {
        if (numeral(budgetTask.cost).value() !== valuesByTaskId[taskId].cost) {
          return true;
        } else if (
          numeral(budgetTask.fee).value() !== valuesByTaskId[taskId].fee
        ) {
          return true;
        } else if (
          numeral(budgetTask.insurance).value() !==
          valuesByTaskId[taskId].insurance
        ) {
          return true;
        } else if (
          numeral(budgetTask.markup).value() !== valuesByTaskId[taskId].markup
        ) {
          return true;
        }
      }
      return false;
    });

    // Check qualifications
    let qualificationsChanged =
      budget.budget_qualifications.length !==
      Object.keys(selectedQualificationsById).length;

    // Check if some qualification changed
    if (!qualificationsChanged) {
      qualificationsChanged = budget.budget_qualifications.some(
        (budgetQualification) =>
          selectedQualificationsById[budgetQualification.qualification_id] ===
          undefined
      );
    }

    //Check if some of the option values has changed
    if (!qualificationsChanged) {
      qualificationsChanged = budget.budget_qualifications.some(
        (budgetQualification) => {
          if (
            selectedQualificationsById[budgetQualification.qualification_id]
              .option !== null &&
            budgetQualification.option !== null
          ) {
            return (
              selectedQualificationsById[budgetQualification.qualification_id]
                .option.label !== budgetQualification.option
            );
          } else {
            return false;
          }
        }
      );
    }

    return taskValuesChanged || qualificationsChanged;
  }
}

export default connect((state) => {
  return {
    budget: getBudget(state),
    currentView: getCurrentView(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    pdf: getPdf(state),
    qualifications: getQualifications(state),
    selectedQualificationsById: getSelectedQualificationsById(state),
    show: getShow(state),
    showPdfViewer: getShowPdfViewer(state),
    tasks: getTasks(state),
    valuesByTaskId: getValuesByTaskId(state),
  };
})(NewBudgetModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/budget/NewBudgetModal.js